<template>
    <tailwind-layout :title="pageTitle">
        <div class="script-container max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
            <div class="bg-white shadow-md rounded-lg overflow-hidden">
                <div class="p-6">
                    <!-- Container where the script might inject an iframe or content -->
                    <div ref="scriptContainer" class="w-full min-h-[500px]"></div>
                </div>
            </div>
        </div>
    </tailwind-layout>
</template>

<script>
import TailwindLayout from '@/Layouts/TailwindLayout.vue'
import { usePage } from '@inertiajs/vue3'

export default {
  name: 'ExternalScriptComponent',
  components: { TailwindLayout },
  props: {
    company: {
      type: String,
      required: true,
    },
    mrcColor: {
      type: String,
      default: '#c3a123',
    },
    mrcColorHover: {
      type: String,
      default: '#323c61',
    },
    scriptSrc: {
      type: String,
      default: 'https://www.mortgageresearchcenter.com/scripts/rentRisk.js',
    },
    pageTitle: {
      type: String,
      default: '',
    }
  },
  mounted() {
    const page = usePage();
    
    // Create and append the script tag dynamically
    const script = document.createElement('script');
    script.src = this.scriptSrc;
    script.async = true;
    script.setAttribute('data-mrc', 'RentRisk');
    script.setAttribute('data-mrc-color', this.mrcColor);
    script.setAttribute('data-mrc-color-hover', this.mrcColorHover);
    if(page.props.user.role === 'applicant') {
      script.setAttribute('data-mrc-desc', 'vafinance');
    }
    if(page.props.user.role === 'agent') {
      script.setAttribute('data-mrc-desc', 'vaready');
    }
    script.onerror = () => console.error('Failed to load script');
    this.$refs.scriptContainer.appendChild(script);
  },
};
</script>

<style scoped>
/* Tailwind handles most styling, but you can add custom styles here if needed */
</style>
